import './assets/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import TheHeader from './components/TheHeader.vue'
import TheFooter from './components/TheFooter.vue'
import i18n from './localization/i18n'
import App from './App.vue'
import router from './router'
import { useLanguageStore } from './stores/language'
import Toast, { POSITION, type PluginOptions } from 'vue-toastification'
import 'vue-toastification/dist/index.css'

const toastOptions: PluginOptions = {
                      position: POSITION.TOP_CENTER,
                      timeout: 5000,
                      closeOnClick: true,
                      pauseOnFocusLoss: true,
                      pauseOnHover: true,
                      draggable: true,
                      draggablePercent: 0.6,
                      showCloseButtonOnHover: false,
                      hideProgressBar: true,
                      closeButton: 'button',
                      icon: true,
                      rtl: false
}
const app = createApp(App).use(i18n)
app.component('TheHeader', TheHeader)
app.component('TheFooter', TheFooter)
app.use(createPinia())
app.use(router)
app.use(Toast, toastOptions)
const languageStore = useLanguageStore()

app.config.errorHandler = (err) => {
  console.log('App error handler', err)
}
app.mount('#app')
